export default {
      id: "icon-book-open-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "icons.svg#icon-book-open",
      toString: function () {
        return this.url;
      }
    }